import classNames from "classnames";
import { components } from "react-select";
import "./style.scss";

const getHeight = (height: "small" | "medium" | "xs") => {
    switch (height) {
        case "small":
            return "36px";
        case "medium":
            return "44px";
        case "xs":
            return "24px";
        default:
            return "44px";
    }
};

export const CustomDropdownIndicator = (props: any) => {
    const { menuIsOpen } = props.selectProps;

    const height = props.selectProps["data-height"];

    return (
        <components.DropdownIndicator {...props}>
            <img src="/angled-arrow-down.svg" className={classNames("dropdown-indicator", menuIsOpen && "open", height)} />
        </components.DropdownIndicator>
    );
};

export const EmptyOptions = (props: any) => {
    return (
        <components.NoOptionsMessage {...props}>
            <div className="empty-options-message">
                <img src="/search-icon.svg" />
                <p>No data found</p>
            </div>
        </components.NoOptionsMessage>
    );
};

export const SingleSelectOption = (props: any & { height: "small" | "medium" | "xs" }) => {
    const height = props.selectProps["data-height"];
    return (
        <components.Option {...props}>
            <div className={classNames("single-select-option", props.isSelected && "checked", height)}>{props.label}</div>
        </components.Option>
    );
};

export const MultiSelectOption = (props: any & { height: "small" | "medium" | "xs" }) => {
    const height = props.selectProps["data-height"];
    return (
        <components.Option {...props}>
            <div className={classNames("multi-select-option", props.isSelected && "checked", height)}>
                <div className="multi-select-option-checkbox">{props.isSelected && <img src="blue-checkmark.svg" />}</div>
                <div className="multi-select-option-label">{props.label}</div>
            </div>
        </components.Option>
    );
};

export const selectStyle = (height: "small" | "medium" | "xs") => ({
    menuPortal: (base: any) => ({
        ...base,
        zIndex: 9999,
        padding: "0"
    }),
    menu: (provided: any) => ({
        ...provided,
        marginTop: "4px",
        boxShadow: "0px 8px 16px 0px #3E134D12",
        border: "1px solid #E5E0EB",
        borderRadius: "8px"
    }),
    control: (provided: any, state: any) => ({
        ...provided,
        width: "100%",
        height: getHeight(height),
        minHeight: getHeight(height),
        border: state.isFocused ? "1px solid #2797E8" : "1px solid #E5E0EB",
        borderRadius: "8px",
        backgroundColor: "#ffffff",
        "&:hover": {
            borderColor: "#2797E8"
        },
        "&:focus": {
            borderColor: "#2797E8",
            borderWidth: "1px"
        },
        fontSize: "12px",
        fontWeight: "400",
        fontFamily: "Poppins",
        color: "#3d4c66",
        boxShadow: "none",
        outline: "none"
    }),
    container: (provided: any) => ({
        ...provided,
        width: "100%"
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        height: getHeight(height),
        minHeight: getHeight(height),
        padding: height === "xs" ? "0 6px" : "0 8px",
        fontSize: "12px",
        fontWeight: "400",
        fontFamily: "Poppins",
        color: "#3d4c66"
    }),
    singleValue: (provided: any) => ({
        ...provided,
        color: "#3d4c66"
    }),
    multiValueLabel: (provided: any) => ({
        ...provided,
        color: "#3d4c66"
    }),
    indicatorsContainer: (provided: any) => ({
        ...provided,
        padding: "0",
        height: getHeight(height)
    }),
    input: (provided: any) => ({
        ...provided,
        margin: "0",
        padding: "0",
        fontSize: "12px",
        fontWeight: "400",
        fontFamily: "Poppins",
        color: "#3d4c66"
    }),
    placeholder: (provided: any) => ({
        ...provided,
        color: "#3d4c66",
        opacity: 0.7
    }),
    option: () => ({})
});
